import React from 'react';
import './style.scss';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const GigCardShell = ({type, gigId, wrapperCls, children, isProExperience, isLimitedEdition}) => {
    const classes = classNames(wrapperCls, 'gig-card-base', 'slide', type, 'js-gig-card', 'js-slide', { 'pro-experience': isProExperience, 'limited-edition-card': isLimitedEdition });

    return (
        <div data-gig-id={gigId} className={classes}>
            {children}
        </div>
    );
};

GigCardShell.propTypes = {
    wrapperCls: PropTypes.string,
    gigId: PropTypes.number,
    type: PropTypes.string,
    children: PropTypes.any,
    isProExperience: PropTypes.bool
};

export default GigCardShell;



// WEBPACK FOOTER //
// ./src/shared/card_shell/index.js